<div>
  <nz-page-header class="bg-slate-100" nzBackIcon [nzGhost]="false">
    <nz-page-header-title *ngIf="isAdd" class="text-primary"
      >{{ 'roles.addEdit.addTitle' | transloco }}</nz-page-header-title
    >
    <nz-page-header-title *ngIf="!isAdd" class="text-primary"
      >{{ 'roles.addEdit.editTitle' | transloco }}</nz-page-header-title
    >
    <nz-page-header-extra>
      <nz-space> </nz-space>
    </nz-page-header-extra>
  </nz-page-header>
</div>
<div class="my-8">
  <div class="grid xl:grid-cols-3 md:grid-cols-2">
    <div class="">
      <form nz-form [formGroup]="roleForm">
        <nz-form-item class="mb-3">
          <nz-form-control class="w-full" [nzErrorTip]="nameError">
            <nz-input-group>
              <label>{{ 'roles.addEdit.roleName' | transloco }}</label>
              <input nz-input formControlName="name" [placeholder]="'roles.addEdit.placeholders.name' | transloco" />
            </nz-input-group>
          </nz-form-control>
          <ng-template #nameError>
            <span>{{ 'roles.addEdit.errors.roleNameRequired' | transloco }}</span>
          </ng-template>
        </nz-form-item>
      </form>
    </div>
  </div>

  <nz-spin [nzSpinning]="isDataLoading">
    <div class="grid xl:grid-cols-3 md:grid-cols-2">
      <nz-divider [nzText]="'roles.addEdit.permissions' | transloco"></nz-divider>
    </div>
    <nz-checkbox-wrapper (nzOnChange)="setPermissions($event)" class="grid">
      <div *ngFor="let permissionObject of allPermissions" class="">
        <h6 class="mb-2">{{ permissionObject?.permissionCategory?.name }}</h6>
        <div
          class="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 xl:grid-cols-9">
          <div
            *ngFor="let permission of permissionObject?.permissions"
            class="mb-6">
            <label
              nz-checkbox
              [nzValue]="permission?._id"
              [ngModel]="isSelectedPermission(permission?._id)"
              >{{ permission?.name }}</label
            >
          </div>
        </div>
        <nz-divider class="mt-0 mb-3"></nz-divider>
      </div>
    </nz-checkbox-wrapper>
    <div class="mt-4">
      <nz-alert
        *ngIf="_isSelectedPermissionsEmpty()"
        class="mt-2"
        nzType="warning"
        [nzMessage]="'roles.addEdit.errors.permissionRequired' | transloco"
        nzShowIcon></nz-alert>
    </div>
  </nz-spin>
  <div class="my-8 text-end">
    <button
      nz-button
      nzType="primary"
      *ngIf="isAdd"
      [disabled]="
        isDataLoading || roleForm.invalid || _isSelectedPermissionsEmpty()
      "
      (click)="addRole()">
      {{ 'roles.addEdit.buttons.add' | transloco }}
    </button>
    <button
      nz-button
      nzType="primary"
      *ngIf="!isAdd"
      [disabled]="
        isDataLoading || roleForm.invalid || _isSelectedPermissionsEmpty()
      "
      (click)="updateRole()">
      {{ 'roles.addEdit.buttons.update' | transloco }}
    </button>
  </div>
  <div>
    <nz-alert
      *ngIf="actionMessage.display && actionMessage.isAdd"
      class="mt-2"
      [nzType]="actionMessage.type"
      [nzMessage]="actionMessage.message"
      nzShowIcon
      nzCloseable></nz-alert>
  </div>
</div>
